export enum TaxType {
  CITY = 'city',
  COUNTRY = 'country',
  STATE = 'state',
  COUNTY = 'county',
  GST = 'gst',
  QST = 'qst',
  PST = 'pst',
  OTHER = 'other',
}
